$(function (e) {
	window.lang = $('html').attr('lang');

	$.ajaxSetup({
	    headers: {
	        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	    }
	});

	function numberWithCommas(x) {
    	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	/* Mobile Check */
	function isMobileTablet(){
	    var check = false;
	    (function(a){
	        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) 
	            check = true;
	    })(navigator.userAgent||navigator.vendor||window.opera);
	    return check;
	}

	/* Build flavour icon */
	function buildFlavourIcon(product_flavours){
		if( product_flavours ){
			$.each( product_flavours, function( index, value ) {
				$('#flavor_part').append(`
					<span class="me-1">
						<i class="flavor-icon" style="background-image:url('`+value.image_path+`');"></i>
						`+value.name+`
					</span>
				`);
			});
		}
	}

	/* size crust section builder*/
	function buildSizeCrust(product_variances, type=''){
		var item_qty = localStorage.getItem('existing_cart_qty') ? localStorage.getItem('existing_cart_qty') : 1;
		var array_id_elements = [];
		$.each( product_variances, function( index, value ) {
			var product_variance_id = value.id;
			if( type === 'deals' ){
				if( value.is_bxf1_deal ){
					var product_price = parseFloat(value.price) * item_qty;
					var product_price_text = '<i class="currency"></i>'+numberWithCommas((product_price).toFixed(0));
				}else{
					var product_price = ( parseFloat(value.menu_surcharge) + parseFloat(value.surcharge) ) * item_qty;
					var product_price_text = '+<i class="currency"></i>'+numberWithCommas((product_price).toFixed(0));
				}
			}else{
				var product_price = parseFloat(value.price) * item_qty;
				var product_price_text = '<i class="currency"></i>'+numberWithCommas((product_price).toFixed(0));
			}
			$('#product_sizes_crusts_select div.product-sizes-crusts-option').each(function(){
			  array_id_elements.push($(this).attr('id')); 
			});
			var size_name = value.size_name ? value.size_name : '';
			var crust_name = value.crust_name ? value.crust_name : '';
			if( array_id_elements.includes( size_name.toLowerCase()+"-option" ) ){
				$('#product_sizes_crusts_select #'+size_name.toLowerCase()+'-option').append(`
					<div data-option="`+size_name+` `+crust_name.toLowerCase()+`" data-price="`+product_price+`" data-size="`+value.size_code+`" data-crust="`+value.crust_code+`" data-id="`+product_variance_id+`" data-size_name="`+size_name+`" data-crust_name="`+crust_name+`" class="product-crust d-flex justify-content-between align-items-center py-2">
							<div class="product-crust-icon d-flex align-items-center">
								<i class="pizzahut-crusts-icons phc-`+value.crust_code.toLowerCase().split(' ').join('-')+` pe-2"></i>
								<span class="text-capitalize px-2 font-weight-600">`+crust_name+`</span>
							</div>
							<div class="product-crust-price px-2 font-weight-600">
								`+product_price_text+`
							</div>
					</div>
				`);
			}else{
				$('#product_sizes_crusts_select').append(`
					<div id="`+size_name.toLowerCase()+`-option" class="product-sizes-crusts-option">
						<h5 class="text-uppercase py-2 mb-2 d-flex align-items-center">`+size_name+`</h5>
						<div data-option="`+size_name+` `+crust_name.toLowerCase()+`" data-price="`+product_price+`" data-size="`+value.size_code+`" data-crust="`+value.crust_code+`" data-id="`+value.id+`" data-size_name="`+size_name+`" data-crust_name="`+crust_name+`" class="product-crust d-flex justify-content-between align-items-center py-2">
							<div class="product-crust-icon d-flex align-items-center">
								<i class="pizzahut-crusts-icons phc-`+value.crust_code.toLowerCase().split(' ').join('-')+` pe-2"></i>
								<span class="text-capitalize px-2 font-weight-600">`+crust_name+`</span>
							</div>
							<div class="product-crust-price px-2 font-weight-600">
								`+product_price_text+`
							</div>
						</div>
					</div>
				`);
			}
		});
	}
	
	/* size crust section builder*/
	function buildSize(product_variances, type=''){	
		var count = 1;
		var item_qty = localStorage.getItem('existing_cart_qty') ? localStorage.getItem('existing_cart_qty') : 1;
		if( typeof product_variances === 'object' ){
			product_variances_array = Object.keys(product_variances).map((key) => product_variances[key]);
			count = product_variances_array.length;
		}else{
			count = product_variances.length;
		}
		$.each( product_variances, function( index, value ) {
			var product_variance_id = value.id;
			var product_price = parseFloat(value.price) * item_qty;
			var product_price_text = '<i class="currency"></i>'+numberWithCommas(product_price.toFixed(0));
			if( type === 'deals' ){
				product_variance_id = index;
				product_price = 0;
				product_price_text = '';
			}
			if( type === 'deals' ||  parseFloat(value.price) > 0 ){
				$('#product_sizes_crusts_select').append(`
					<div id="`+value.size_name.toLowerCase()+`-option" class="product-sizes-crusts-option">
						<div data-option="`+value.size_name.toLowerCase()+`" data-price="`+product_price+`" data-size="`+value.size_code+`" data-crust="`+value.size_name+`" data-id="`+product_variance_id+`" data-size_name="`+value.size_name+`" data-crust_name="`+value.crust_name+`" class="product-crust d-flex justify-content-between align-items-center py-2">
							<div class="product-crust-icon d-flex align-items-center">
								<span class="text-capitalize px-2 font-weight-600">`+value.size_name+`</span>
							</div>
							<div class="product-crust-price px-2 font-weight-600">
								`+product_price_text+`
							</div>
						</div>
					</div>
				`);
			}
			if( count === 1 ){
				$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr( 'data-price', product_price);
				$('#product_subtotal').html( '+ <i class="currency"></i>'+numberWithCommas(parseFloat(product_price).toFixed(0)));
				$('.product-selected-size-crust span').html(value.size_name.toLowerCase());
				$('#product_sizes_crusts_select').addClass('d-none');
				$('.product-selected-size-crust').removeClass('d-none');
				$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').prop('disabled', false);
			}
		});
	}

	/* Toppings builder*/
	function buildTopping(product_ingredients){
		var item_qty = localStorage.getItem('existing_cart_qty') ? localStorage.getItem('existing_cart_qty') : 1;
		$('#product_topping_default').html('');
		$('#product_topping_extra').html('');
		var filter_default_toppings = product_ingredients.filter(function(e){
				return e.default == 1 && e.active == 1;
			});
		var filter_default_topping_codes = filter_default_toppings.map(function(v){
				return v.ingredient_code;
			});
		var filter_extra_toppings = product_ingredients.filter(function(e){
				return e.default == 0 && e.active == 1;
			});
		var filter_extra_topping_codes =filter_extra_toppings.map(function(v){
				return v.ingredient_code;
			});
		if( filter_default_toppings.length > 0 ){
			$('.product-toppings-default').removeClass('d-none');
			$('#product_topping_default').attr('data-default_toppings', filter_default_topping_codes);
			$.each( filter_default_toppings, function( index, value ) {
				$.each( value.price, function( i, k ) {
					$('#product_topping_default').append(`
						<div class="size-`+i+` product-topping-default-option d-none justify-content-between align-items-center p-2">
							<div class="topping-icon d-flex align-items-center text-capitalize">
								<i class="pizzahut-toppings-icons phc-icon-`+value.ingredient_code.toLowerCase()+` pe-2"></i>`+value.ingredient_name.toLowerCase()+`
							</div>
							<div class="topping-action d-flex align-items-center">
								<button data-code="`+value.ingredient_code+`" data-name="`+value.ingredient_name+`" data-size="`+i+`" data-price="`+(parseFloat(k.price) * item_qty).toFixed(0)+`" data-action="remove" class="ps-2 remove-topping-btn outline-0 d-flex">
									<i class="remove-topping"></i>
								</button>
							</div>
						</div>
					`);
				});
			});
		}else{
			$('.product-toppings-default').addClass('d-none');
		}
		if( filter_extra_toppings.length > 0 ){
			$('.product-toppings-extra').removeClass('d-none');
			$('#product_topping_extra').attr('data-extra_toppings', filter_extra_topping_codes);
			$.each( filter_extra_toppings, function( index, value ) {
				$.each( value.price, function( i, k ) {
					$('#product_topping_extra').append(`
						<div class="size-`+i+` d-none product-topping-extra-option justify-content-between align-items-center p-2">
							<div class="topping-icon d-flex align-items-center text-capitalize">
								<i class="pizzahut-toppings-icons phc-icon-`+value.ingredient_code.toLowerCase()+` pe-2"></i>`+value.ingredient_name.toLowerCase()+`
							</div>
							<div class="topping-action d-flex align-items-center">
								<div class="d-flex topping-extra-price">
									+<i class="currency"></i>`+numberWithCommas((parseFloat(k.price) * item_qty).toFixed(0))+`
								</div>
								<button data-code="`+value.ingredient_code+`" data-name="`+value.ingredient_name+`" data-size="`+i+`" data-action="add" data-price="`+(parseFloat(k.price) * item_qty).toFixed(0)+`" class="ps-2 outline-0 add-topping-btn d-flex"><i class="add-topping"></i>
								</button>
							</div>
						</div>
					`);
				});
			});
		}else{
			$('.product-toppings-extra').addClass('d-none');
		}
		sortingToppings( '#product_topping_default', '.product-topping-default-option:not(.extra-topping)');
		sortingToppings( '#product_topping_extra', '.product-topping-extra-option:not(.default-topping)');
	}

	/* sort topping after add */
	function sortingToppings( element, child_element){
		var listitems = $(element).children(child_element).get();
		listitems.sort(function(a, b){
			return b.outerText.toUpperCase().localeCompare(a.outerText.toUpperCase());
		});
		$.each(listitems, function(index, item) {
		   $(element).prepend(item); 
		});
	}

	/* Remove / Add Topping Function */
	function ToppingUpgrades(upgrade, code, name, action, price){
		if( !upgrade || upgrade == "" ){
			var upgrade_obj = [
				{"code":code, "name":name, "action":action, "price":parseFloat(price)}
			];
		}else{
			var upgrade_obj = JSON.parse(upgrade);
			var oposite_action = action == 'add' ? 'remove' : 'add';
			var filter_upgrade_by_code = upgrade_obj.filter(function(o){return o.code == code;});
			if( filter_upgrade_by_code.length > 0 ){
				var filter_upgrade_by_action = _.filter(filter_upgrade_by_code, function(o){ return o.action == oposite_action;});
				if( filter_upgrade_by_action.length > 0 ){
					var new_upgrade = [];
					var count = 0;
					$.each( upgrade_obj, function(key,data){
						if( data.action == oposite_action && data.code == code && count == 0 ){
							count += 1;
						}else{
							new_upgrade.push(data);
						}
					});
					upgrade_obj = new_upgrade;
				}else{
					upgrade_obj.push({"code":code, "name":name, "action":action, "price":parseFloat(price)});
				}
			}else{
				upgrade_obj.push({"code":code, "name":name, "action":action, "price":parseFloat(price)});
			}
		}
		var local_storage_upgrade = upgrade_obj.length > 0 ? JSON.stringify(upgrade_obj) : '';
		localStorage.setItem('toppings_upgrade', local_storage_upgrade);
		return upgrade_obj;
	}

	/* add / remove topping notes */
	function toppingsAddNote(upgrade){
		var add_topping = new Array();
		var remove_topping = new Array();
		var str_add_topping = '';
		var str_remove_topping = '';
		var add_text = Lang.get('js-return-text.label_add_topping');
		var remove_text = Lang.get('js-return-text.label_remove_topping');
		if( upgrade.length > 0 ){
			$.each(upgrade, function( key, value ){
				if( value.action == 'remove' ){
					remove_topping.push(value.name.toLowerCase());
				}else{
					add_topping.push(value.name.toLowerCase());
				}
			});
		}
		if( add_topping.length > 0 ){
			str_add_topping = add_text+' '+(add_topping.join(', '));
		}
		if( remove_topping.length > 0 ){
			str_remove_topping = remove_text+' '+(remove_topping.join(', '));
		}
		$('#additional_note').html(str_add_topping);
		$('#removed_note').html(str_remove_topping);
	}

	/* Add items cart */
	function addItemCart(carts){
		$('.basket-items-wrap').html('');
		$('.basket-items-wrap').addClass('bg-white');
		var product_type = $('#basket').attr('data-type');
		var product_type_array = JSON.parse(product_type);
		$.each( JSON.parse(carts), function( index, value ) {
			var size_name = '';
			var crust_name = '';
			var product_name = '';
			if( value.size_name !== null  ){
				if( lang == 'th' ){
					size_name = value.size_name_thai.toLowerCase();	
				}else{
					size_name = value.size_name.toLowerCase();	
				}
			}
			if( value.crust_name !== null ){
				if( lang == 'th' ){
					crust_name = value.crust_name_thai.toLowerCase()	
				}else{
					crust_name = value.crust_name.toLowerCase()	
				}
			}
			if( value.product_name !== null ){
				if( lang == 'th' ){
					product_name = value.product_name_thai.toLowerCase()
				}else{
					product_name = value.product_name.toLowerCase()	
				}
			}

			var drinks_dessert_type_array = ['DRINK', 'DESSERT', 'GIFT'];
			var product_size_text = "";

			if( lang == 'th' && !drinks_dessert_type_array.includes(value.type) ) {
				product_size_text = product_name + size_name;
			} else {
				product_size_text = size_name +` `+ product_name;
			}

			$('.basket-items-wrap').append(`
				<div id="item-`+index+`" class="d-flex basket-single-item justify-content-between align-items-start mb-4">
				</div>
			`);
			var category_type = localStorage.getItem('category_type');
			if( ( value.crust_name !== null && value.size_name !== null ) || !product_type_array.includes(value.type) ){
				if( !product_type_array.includes(value.type) ){
					var unit_total = parseFloat(value.price)*value.qty;
				}else{
					var unit_total = (parseFloat(value.price)+parseFloat(value.surcharge))*value.qty;
				}
				$('#item-'+index).append(`
					<button class="collapse-button me-1" data-bs-toggle="collapse" data-bs-target="#item-info-`+index+`" aria-controls="item-info-`+index+`" aria-expanded="true">
						<i class="pizzahut-icons phc-expand-more"></i>
					</button>
				`);
				var string_value = JSON.stringify(value);
				var text_red = value.available ? '' : 'text-red';
				var storage_url = localStorage.getItem('storage_domain_url');
				var trigger_modal_a_tag = `<a class="edit-product-builder-btn flex-fill" rel="`+product_name+`" data-bs-target="#product-builder-modal" data-sku="`+value.sku+`" data-domain="`+storage_url+`" data-id="`+index+`" data-category="`+category_type+`">`;
				var trigger_modal_a_tag_close = `</a>`;
				if( !product_type_array.includes(value.type) ){
					trigger_modal_a_tag = `<a rel="`+product_name+`" href="/cart/edit-deal/`+index+`/`+value.slug+`" class="text-decoration-none flex-fill">`;
				}
				if( value.available == false ){
					trigger_modal_a_tag = ``;
					trigger_modal_a_tag_close = ``;
				}
				$('#item-'+index).append(`
                    <div class="single-item-details">
                        <div class="item-info font-family-theme d-flex fw-bold justify-content-between align-items-center">
                            <div class="col-9 d-flex">
                                <span class="mx-2 edit-quantity-modal text-pink border-0 fs-rem-1" data-id="`+index+`" data-name="`+product_name+`" data-quantity="`+value.qty+`" data-sku="`+value.sku+`" data-domain="`+storage_url+`">x`+value.qty+`</span>
                                <span>
                                    <span class="item-name text-capitalize flex-fill `+text_red+`">`+product_size_text+`</span>
                                    <br>
                                    <span>
                                        <button class="border-0 rounded-pill edit-item-btn small fw-semibold">Edit</button>
                                    </span>
                                </span>
                            </div>
                            <div class="col-3 center-text">
                                <button class="remove-btn ms-1" data-id="`+index+`" data-remove="#item-`+index+`" data-sku="`+value.sku+`" data-qty="`+value.qty+`">
                                    <i class="pizzahut-icons phc-close-grey"></i>
                                </button>
                                <br>
                                <span class="item-price `+text_red+`"><i class="currency"></i>`+numberWithCommas((unit_total).toFixed(0))+`</span>
                            </div>
                        </div>
                    </div>
				`);
				if( product_type_array.includes(value.type) && value.available ){
					$('.edit-product-builder-btn[data-sku='+value.sku+'][data-id='+index+']').attr('data-cart', string_value);
				}
				if( !product_type_array.includes(value.type) ){
					$.each( value.items, function( item_key, item ) {
						var item_size_name = '';
						var item_crust_name = '';
						var item_product_name = '';
						var item_product_price = '';
						if( item['size_name'] !== null  ){
							if( lang == 'th' ){
								item_size_name = item['size_name_thai'].toLowerCase();
							}else{
								item_size_name = item['size_name'].toLowerCase();
							}
						}
						if( item['crust_name'] !== null ){
							if( lang == 'th' ){
								item_crust_name = item['crust_name_thai'].toLowerCase();
							}else{
								item_crust_name = item['crust_name'].toLowerCase();
							}
						}
						if( item['product_name'] !== null ){
							if( lang == 'th' ){
								item_product_name = item['product_name_thai'].toLowerCase();
							}else{
								item_product_name = item['product_name'].toLowerCase();
							}
						}

						var drinks_dessert_type_array = ['DRINK', 'DESSERT', 'GIFT'];
						var product_size_text = "";

						if( lang == 'th' && !drinks_dessert_type_array.includes(value.type) ) {
							product_size_text = item_product_name + item_size_name;
						} else {
							product_size_text = item_size_name +` `+ item_product_name;
						}

						if( parseFloat(item['price']) > 0 ){
							if( value.buy_x_free_x ){
								item_product_price = '<i class="currency"></i>'+numberWithCommas(parseFloat(item['price']).toFixed(0));
							} else {
								item_product_price = '+<i class="currency"></i>'+numberWithCommas(parseFloat(item['price']).toFixed(0));
							}
						}
						if( value.available ){
							$( '#item-info-'+index+' a' ).append(`
								<div class="justify-content-between d-flex">
									<span class="item-type text-capitalize me-2"><span class="font-weight-600">
									`+product_size_text+`
									</span></span>
									<span class="item-additional">`+item_product_price+`</span>
								</div>
							`);
						}else{
							$( '#item-info-'+index ).append(`
								<div class="justify-content-between d-flex">
									<span class="item-type text-capitalize me-2"><span class="font-weight-600">
									`+product_size_text+`
									</span></span>
									<span class="item-additional">`+item_product_price+`</span>
								</div>
							`);
						}
						
						$( '#item-info-'+index ).append(`
								<div class="justify-content-between d-flex">
									<span class="item-type text-capitalize me-2">
										`+item_crust_name+`
									</span>
									<span class="item-additional"></span>
								</div>
							`);
						if( item['upgrades'] && typeof item['upgrades'] === 'object' && item['upgrades'] !== null ){
							var obj_upgrades = item['upgrades'];
							$.each( obj_upgrades, function( item_upgrade_key, item_upgrade ) {
								var item_upgrade_name = '';
								var item_upgrade_add = Lang.get('js-return-text.text_add_topping');
								var item_upgrade_remove = Lang.get('js-return-text.text_no_topping');
								if( lang == 'th' ){
									item_upgrade_name = item_upgrade['name_thai'].toLowerCase();
								}else{
									item_upgrade_name = item_upgrade['name'].toLowerCase();
								}
								if( item_upgrade['action'] == 'remove' ){
									$( '#item-info-'+index ).append(`
										<div class="justify-content-between d-flex">
											<span class="item-type text-capitalize me-2">
											<span class="text-theme-red">`+item_upgrade_remove+'</span> '+item_upgrade_name+`
											</span>
											<span class="item-additional"></span>
										</div>
									`);
								}else{
									$( '#item-info-'+index ).append(`
										<div class="justify-content-between d-flex">
											<span class="item-type text-capitalize me-2">
											<span class="text-green">`+item_upgrade_add+'</span> '+item_upgrade_name+`
											</span>
											<span class="item-additional">
												+<i class="currency"></i>`+numberWithCommas((parseFloat(item_upgrade['price'])*value.qty).toFixed(0))+`
											</span>
										</div>
									`);	
								}
							});
						}
					});
				}else{
					if( value.available ){
						$( '#item-info-'+index+' a' ).append(`
							<div class="justify-content-between d-flex">
								<span class="item-type text-capitalize me-2"><span class="font-weight-600">
								`+crust_name+`
								</span></span>
								<span class="item-additional"></span>
							</div>
						`);
					}else{
						$( '#item-info-'+index ).append(`
							<div class="justify-content-between d-flex">
								<span class="item-type text-capitalize me-2"><span class="font-weight-600">
								`+crust_name+`
								</span></span>
								<span class="item-additional"></span>
							</div>
						`);
					}
					if( value.upgrades ){
						var upgrades = value.upgrades;
						upgrades.sort(function (a, b) {
						  	var actionA = a.action.toUpperCase();
							var actionB = b.action.toUpperCase();
							if (actionA < actionB) {
							   return -1;
							}
							if (actionA > actionB) {
							   return 1;
							}
							return 0;
						}); // sort
					}
					$.each( upgrades, function( key, upgrade ) {
						var upgrade_name = '';
						var upgrade_add = Lang.get('js-return-text.text_add_topping');
						var upgrade_remove = Lang.get('js-return-text.text_no_topping');
						if( lang == 'th' ){
							upgrade_name = upgrade['name_thai'].toLowerCase();
						}else{
							upgrade_name = upgrade['name'].toLowerCase();
						}
						if( upgrade['action'] == 'remove' ){
							if( value.available ){
								$( '#item-info-'+index+' a' ).append(`
									<div class="justify-content-between d-flex">
										<span class="item-type text-capitalize me-2">
										<span class="text-theme-red">`+upgrade_remove+'</span> '+upgrade_name+`
										</span>
										<span class="item-additional"></span>
									</div>
								`);
							}else{
								$( '#item-info-'+index ).append(`
									<div class="justify-content-between d-flex">
										<span class="item-type text-capitalize me-2">
										<span class="text-theme-red">`+upgrade_remove+'</span> '+upgrade_name+`
										</span>
										<span class="item-additional"></span>
									</div>
								`);
							}
						}else{
							if( value.available ){
								$( '#item-info-'+index+' a' ).append(`
									<div class="justify-content-between d-flex">
										<span class="item-type text-capitalize me-2">
										<span class="text-green">`+upgrade_add+'</span> '+upgrade_name+`
										</span>
										<span class="item-additional">+<i class="currency"></i>`+numberWithCommas((parseFloat(upgrade['price'])*value.qty).toFixed(0))+`</span>
									</div>
								`);	
							}else{
								$( '#item-info-'+index ).append(`
									<div class="justify-content-between d-flex">
										<span class="item-type text-capitalize me-2">
										<span class="text-green">`+upgrade_add+'</span> '+upgrade_name+`
										</span>
										<span class="item-additional">+<i class="currency"></i>`+numberWithCommas((parseFloat(upgrade['price'])*value.qty).toFixed(0))+`</span>
									</div>
								`);
							}
						}
					});
				}
			}else{
				if( !product_type_array.includes(value.type) ){
					var unit_total = parseFloat(value.price)*value.qty;
				}else{
					var unit_total = (parseFloat(value.price)+parseFloat(value.surcharge))*value.qty;
				}
				var string_value = JSON.stringify(value);
				var storage_url = localStorage.getItem('storage_domain_url');
				var text_red = value.available ? '' : 'text-red';
				if( value.variances_count  > 1 && value.available ){
					var trigger_modal_a_tag = `<a class="edit-product-builder-btn flex-fill" rel="`+product_name+`" data-bs-target="#product-builder-modal" data-sku="`+value.sku+`" data-domain="`+storage_url+`" data-id="`+index+`" data-category="`+category_type+`">`;	
					var close_modal_a_tag = `</a>`;
				}else{
					var trigger_modal_a_tag = '';
					var close_modal_a_tag = '';
				}
				
				$('#item-'+index).append(`
					<div class="single-item-details">
						<div class="item-info font-family-theme font-weight-700 d-flex justify-content-between">
							`+trigger_modal_a_tag+`
								<span class="item-name flex-fill text-capitalize custom-width `+text_red+`">`+product_size_text+`</span>
							`+close_modal_a_tag+`
							<span class="mx-2 edit-quantity-modal" data-id="`+index+`" data-name="`+product_name+`" data-quantity="`+value.qty+`" data-sku="`+value.sku+` data-domain="`+storage_url+`">x`+value.qty+`</span>
							<span class="item-price `+text_red+`"><i class="currency"></i>`+numberWithCommas((unit_total).toFixed(0))+`</span>
						</div>
					</div>
				`);
				$('.edit-product-builder-btn[data-sku='+value.sku+'][data-id='+index+']').attr('data-cart', string_value);
			}
			// $('#item-'+index).append(`
			// 	<button class="remove-btn ms-1" data-id="`+index+`" data-remove="#item-`+index+`" data-sku="`+value.sku+`" data-qty="`+value.qty+`">
			// 		<i class="pizzahut-icons phc-close-grey"></i>
			// 	</button>
			// `);
		});
	}

	/* Generate array deals items */
	function addItemToDeal(data, key){
		var get_current_deal_data = $('input[name=items]').val();

		if( get_current_deal_data ){
			get_current_deal_data = JSON.parse(get_current_deal_data);
			var r_upgrade = data.upgrades;
			var deal_items = {
				sku: data.sku,
				crust_code: data.crust_code,
				size_code: data.size_code,
				type: data.type_name,
				price: data.price,
				qty: 1,
				upgrades: r_upgrade,
				total_price: data.price
			};
			get_current_deal_data[key] = deal_items;
		}else{
			get_current_deal_data = [];
			if( key > 0 ){
				for(var i = 0; i <= key; i++ ){
					if( i == key ){
						var r_upgrade = data.upgrades;
						var deal_items = {
							sku: data.sku,
							crust_code: data.crust_code,
							size_code: data.size_code,
							type: data.type_name,
							price: data.price,
							qty: 1,
							upgrades: r_upgrade,
							total_price: data.price
						};
						get_current_deal_data[i] = deal_items;
					}else{
						var deal_items = [];
						get_current_deal_data[i] = deal_items;
					}
				}
			}else{
				var r_upgrade = data.upgrades;
				var deal_items = {
					sku: data.sku,
					crust_code: data.crust_code,
					size_code: data.size_code,
					type: data.type_name,
					price: data.price,
					qty: 1,
					upgrades: r_upgrade,
					total_price: data.price
				};
				get_current_deal_data[key] = deal_items;
			}
		}
		return JSON.stringify(get_current_deal_data);
	}

	/* Remove Item to Deal */
	function removeItemToDeal(data){
		var get_current_deal_data = $('input[name=items]').val();
		if( get_current_deal_data ){
			get_current_deal_data = JSON.parse(get_current_deal_data);
			get_current_deal_data[data.id] = {};
		}else{
			get_current_deal_data = [];
		}
		return JSON.stringify(get_current_deal_data);
	}

	/* Calculate new point */
	function calculateNewPoint( total_amount ){
		var current_point = parseInt($('#available_reward').attr('data-available_reward'));
		var breakdown_amount = parseInt($('#available_reward').attr('data-breakdown_point'));
		var earn_point = 0;
		var total_point = 0;
		if( total_amount > 0 ){
			earn_point = ( total_amount - ( total_amount % breakdown_amount ) ) / breakdown_amount;
			total_point = current_point + earn_point;
		}
		return { 'earn_point' : earn_point,  'total_point' : total_point };
	}

	/* build remove topping */
	function buildRemovedTopping(size,code,name,price){
		$('#product_topping_extra').prepend(`
			<div class="default-topping size-`+size+` product-topping-extra-option d-flex justify-content-between align-items-center p-2">
				<div class="topping-icon d-flex align-items-center text-capitalize">
					<i class="pizzahut-toppings-icons phc-icon-`+code.toLowerCase()+` pe-2"></i>
					`+name.toLowerCase()+`
				</div>
				<div class="topping-action d-flex align-items-center">
					<button data-code="`+code+`" data-name="`+name+`" data-action="add" data-price="`+price+`" class="ps-2 add-topping-btn outline-0 d-flex">
						<i class="add-topping"></i>
					</button>
				</div>
			</div>
		`);
	}

	/* build add topping */
	function buildAddedTopping(size,code,name,price,with_price='Yes'){
		if( with_price == 'No'  ){
			$('#product_topping_default').append(`
				<div class="size-`+size+` product-topping-default-option d-flex justify-content-between align-items-center p-2">
					<div class="topping-icon d-flex align-items-center text-capitalize">
						<i class="pizzahut-toppings-icons phc-icon-`+code.toLowerCase()+` pe-2"></i>`+name.toLowerCase()+`
					</div>
					<div class="topping-action d-flex align-items-center">
						<button data-code="`+code+`" data-name="`+name+`" data-size="`+size+`" data-price="`+price+`" data-action="remove" class="ps-2 remove-topping-btn outline-0 d-flex">
							<i class="remove-topping"></i>
						</button>
					</div>
				</div>
			`);
			sortingToppings( '#product_topping_default', '.product-topping-default-option:not(.extra-topping)');
		}else{
			$('#product_topping_default').append(`
				<div class="extra-topping size-`+size+` product-topping-default-option d-flex justify-content-between align-items-center p-2">
					<div class="topping-icon d-flex align-items-center text-capitalize">
						<i class="pizzahut-toppings-icons phc-icon-`+code.toLowerCase()+` pe-2"></i>
						`+name.toLowerCase()+`
					</div>
					<div class="topping-action d-flex align-items-center">
						<div class="d-flex topping-extra-price">
							+<i class="currency"></i>`+numberWithCommas((parseFloat(price)).toFixed(0))+`
						</div>
						<button data-code="`+code+`" data-name="`+name+`" data-size="`+size+`" data-price="`+price+`" data-action="remove" class="ps-2 remove-topping-btn outline-0 d-flex">
							<i class="remove-topping"></i>
						</button>
					</div>
				</div>
			`);
		}
	}

	/* if mobile scroll to active links */
	if( $(window).width() < 640 ){
		var current_url = document.URL.substring(document.URL.lastIndexOf('/') + 1);
		var menu_pages = ['deals', 'pizzas', 'pastas', 'appetizers', 'drinks-&-desserts'];
		if( menu_pages.includes(current_url) ){
			var window_width = $( window ).width();
			var active_link_width = $('#mobile_menu .menu-links.active').width();
			var active_link_left = $('#mobile_menu .menu-links.active').offset().left;
			var active_link = Math.round(active_link_width+active_link_left);
			var total_length = $('#mobile_menu .scroll-menu .menu-navbar-inner').width();
			if( active_link == total_length ){
				$('#mobile_menu .scroll-menu').scrollLeft(active_link_left);	
			}else if( active_link > window_width/2 ){
				var offset_left = Math.abs(active_link_left - (window_width/2));
				$('#mobile_menu .scroll-menu').scrollLeft(offset_left);
			}
		}
	}

	/* Hide Basket Modal in device width bigger than 960 */
	$( window ).resize(function() {
  		if( $(window).width() >= 960 ){
			$('#basket-modal').modal('hide');	
		}
	});

	/* view basket */
	$('body').on('click', '.view-basket-btn', function(e){
		$('#basket-modal').addClass('active');
		$('body').addClass('modal-open');
	});

	/* Change Pizza Size In Select Box */
	$('body').on('change', 'select[name=pizza-size]', function(e){
	    var current_price = parseFloat($(this).find(':selected').attr('data-price')).toFixed(0);
	    var crust_code = $(this).find(':selected').attr('data-crust_code');
	    var size_code = $(this).find(':selected').attr('data-size_code');
	    var crust_name = $(this).find(':selected').attr('data-crust_name');
	    var size_name = $(this).find(':selected').attr('data-size_name');
	    var bxf1 = $(this).find(':selected').attr('data-bxf1');

	    var button = $(this).parent('.product-grid-selectbox').next('.add-product-cart');
	    var button_deals = $(this).parent('.product-grid-selectbox').next('.add-to-deals');
	    
	    button.children('.product-price-btn').html('<i class="currency"></i>'+current_price);
	    if( bxf1 ){
	    	button_deals.children('.product-price-btn').html('<i class="currency"></i>'+current_price);
	    } else {
	    	button_deals.children('.product-price-btn').html('+<i class="currency"></i>'+current_price);
	    }

	    /* button product grid */
	    button.attr('data-price', current_price);
	    button.attr('data-crust_code', crust_code);
	    button.attr('data-size_code', size_code);
	    /* button product deals grid */
	    button_deals.attr('data-price', current_price);
	    button_deals.attr('data-variance_price', current_price);
	    button_deals.attr('data-crust_code', crust_code);
	    button_deals.attr('data-size_code', size_code);
	    button_deals.attr('data-crust_name', crust_name);
	    button_deals.attr('data-size_name', size_name);
	});

	/* remove topping */
	$('body').on('click', '.remove-topping-btn:not(.disabled-button)', function(e){
		var extra_toppings = $('#product_topping_extra').attr('data-extra_toppings');
		var default_toppings = $('#product_topping_default').attr('data-default_toppings');	
		var total_price = $('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-price');
		var upgrade = $('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-upgrades');
		var code = $(this).attr('data-code');
		var name = $(this).attr('data-name');
		var action = $(this).attr('data-action');
		var price = $(this).attr('data-price');
		var size = $(this).attr('data-size');
		var new_total_price = parseFloat(total_price);
		var return_new_upgrade_obj = ToppingUpgrades(upgrade, code, name, action, price);
		var remove_filter_upgrade = _.filter(return_new_upgrade_obj, function(o){ return o.action == 'remove' });
		var new_upgrade = return_new_upgrade_obj.length > 0 ? JSON.stringify(return_new_upgrade_obj) : '';
		var is_buy_x_free_x = $('.add-to-deals').attr('data-buy_x_free_x');
		if( remove_filter_upgrade.length <= 2 ){
			toppingsAddNote( return_new_upgrade_obj );
			$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-upgrades', new_upgrade );
			if( !extra_toppings ){
				$(this).attr('data-action', 'add');
				$(this).removeClass('remove-topping-btn').addClass('add-topping-btn');
				$(this).html('<i class="add-topping"></i>');
			}else{
				if( upgrade ){
					var upgrade_array = JSON.parse(upgrade);
					var add_filter_upgrade = _.filter(upgrade_array, function(o){ return o.action == 'add' });
					var add_topping_codes = _.map(add_filter_upgrade, 'code');
					if( add_filter_upgrade.length > 0 ){
						$(this).parent().parent().remove();
						if( extra_toppings.includes(code) && default_toppings.includes(code) ){
							if( add_topping_codes.includes(code) ){
								new_total_price -= parseFloat(price);
								$('#product_topping_default .product-topping-default-option.d-flex.size-'+size+' button[data-code='+code+']').first().prev().addClass('d-none').removeClass('d-flex');	
							}else{
								$('#product_topping_extra .product-topping-extra-option.d-flex.size-'+size+' button[data-code='+code+']').prev().addClass('d-none').removeClass('d-flex');
								$('#product_topping_extra .product-topping-extra-option.d-flex.size-'+size+' button[data-code='+code+']').parent().parent().addClass('default-topping').removeClass('disabled-topping');
								$('#product_topping_extra .product-topping-extra-option.d-flex.size-'+size+' button[data-code='+code+']').removeClass('disabled-button');
							}
						}else{
							if( default_toppings.includes(code) ){

								buildRemovedTopping(size,code,name,parseFloat(price));
							}else{
								new_total_price -= parseFloat(price);
							}
						}
					}else{
						$(this).parent().parent().remove();
						if( extra_toppings.includes(code) ){
							$('#product_topping_extra .product-topping-extra-option.d-flex.size-'+size+' button[data-code='+code+']').prev().addClass('d-none').removeClass('d-flex');
							$('#product_topping_extra .product-topping-extra-option.d-flex.size-'+size+' button[data-code='+code+']').parent().parent().addClass('default-topping').removeClass('disabled-topping');
							$('#product_topping_extra .product-topping-extra-option.d-flex.size-'+size+' button[data-code='+code+']').removeClass('disabled-button');
						}else{
							buildRemovedTopping(size,code,name,parseFloat(price));
						}
					}
				}else{
					$(this).parent().parent().remove();
					if( !extra_toppings.includes(code) ){
						buildRemovedTopping(size,code,name,parseFloat(price));
					}else{
						$('#product_topping_extra .product-topping-extra-option.d-flex.size-'+size+' button[data-code='+code+']').prev().addClass('d-none').removeClass('d-flex');
						$('#product_topping_extra .product-topping-extra-option.d-flex.size-'+size+' button[data-code='+code+']').parent().parent().addClass('default-topping').removeClass('disabled-topping');
						$('#product_topping_extra .product-topping-extra-option.d-flex.size-'+size+' button[data-code='+code+']').removeClass('disabled-button');
					}
				}
			}
			if( new_upgrade ){
				var filter_upgrade = _.filter(JSON.parse(new_upgrade) , function(o){ return o.action == 'remove' });
				var add_filter_upgrade_new = _.filter(JSON.parse(new_upgrade), function(o){ return o.action == 'add' });
				if( filter_upgrade && filter_upgrade.length > 1 ){
					$('#product_topping_default button[data-action=remove]').addClass('disabled-button');
					$('#product_topping_default button[data-action=remove]').parent().parent().addClass('disabled-topping');	
					$('#product_topping_default .extra-topping').removeClass('disabled-topping');
					$('#product_topping_default .extra-topping button[data-action=remove]').removeClass('disabled-button');
				}
				if( add_filter_upgrade_new && add_filter_upgrade_new.length <= 1 ){
					$('#product_topping_extra button[data-action=add]').removeClass('disabled-button');
					$('#product_topping_extra button[data-action=add]').parent().parent().removeClass('disabled-topping');
				}
			}
			$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-price', parseFloat(new_total_price).toFixed(0));
			if(is_buy_x_free_x){
				$('span#product_subtotal').html(`<i class="currency"></i>`+ numberWithCommas(parseFloat(new_total_price).toFixed(0)));
			}else{
				$('span#product_subtotal').html(`+ <i class="currency"></i>`+ numberWithCommas(parseFloat(new_total_price).toFixed(0)));
			}
		}else{
			// console.log('Maximum remove 2 toppings');
		}
	});

	/* add topping */
	$('body').on('click', '.add-topping-btn:not(.disabled-button)', function(e){
		var extra_toppings = $('#product_topping_extra').attr('data-extra_toppings');
		var default_toppings = $('#product_topping_default').attr('data-default_toppings');	
		var total_price = $('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-price');
		var upgrade = $('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-upgrades');
		var code = $(this).attr('data-code');
		var name = $(this).attr('data-name');
		var action = $(this).attr('data-action');
		var price = $(this).attr('data-price');
		var size = $(this).attr('data-size');
		var new_total_price = parseFloat(total_price);
		var return_new_upgrade_obj = ToppingUpgrades(upgrade, code, name, action, price);
		var filter_upgrade_add = _.filter(return_new_upgrade_obj, function(o){ return o.action == 'add' });
		var new_upgrade = return_new_upgrade_obj.length > 0 ? JSON.stringify(return_new_upgrade_obj) : '';
		var is_buy_x_free_x = $('.add-to-deals').attr('data-buy_x_free_x');
		if( filter_upgrade_add.length <= 2 ){
			toppingsAddNote( return_new_upgrade_obj );
			$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-upgrades', new_upgrade );
			if( !extra_toppings ){
				$(this).attr('data-action', 'remove');
				$(this).removeClass('add-topping-btn').addClass('remove-topping-btn');
				$(this).html('<i class="remove-topping"></i>');
			}else{
				if( upgrade ){
					var upgrade_array = JSON.parse(upgrade);
					var filter_upgrade_remove = _.filter(upgrade_array,function(o){return o.action=='remove'});
					var remove_topping_codes = _.map(filter_upgrade_remove, 'code');
					if( filter_upgrade_remove.length > 0 ){
						if( default_toppings.includes(code) && remove_topping_codes.includes(code) ){
							buildAddedTopping(size,code,name,parseFloat(price),with_price='No');
							if( extra_toppings.includes(code) ){
								$(this).prev().removeClass('d-none').addClass('d-flex');	
							}else{
								$(this).parent().parent().remove();
							}
						}else{
							buildAddedTopping(size,code,name,parseFloat(price));
							new_total_price += parseFloat(price);
						}
					}else{
						buildAddedTopping(size,code,name,parseFloat(price));
						new_total_price += parseFloat(price);
					}
				}else{
					buildAddedTopping(size,code,name,price);
					new_total_price += parseFloat(price);
				}
			}
			if( new_upgrade ){
				var filter_upgrade_add = _.filter(JSON.parse(new_upgrade),function(o){return o.action=='add'});
				var filter_upgrade_remove_new = _.filter(JSON.parse(new_upgrade),function(o){return o.action=='remove'});
				if( filter_upgrade_add && filter_upgrade_add.length > 1 ){
					$('#product_topping_extra button[data-action=add]').addClass('disabled-button');
					$('#product_topping_extra button[data-action=add]').parent().parent().addClass('disabled-topping');
					$('#product_topping_extra .default-topping').removeClass('disabled-topping');
					$('#product_topping_extra .default-topping button[data-action=add]').removeClass('disabled-button');
				}
				if( filter_upgrade_remove_new.length <= 1 ){
					$('#product_topping_default button[data-action=remove]').removeClass('disabled-button');
					$('#product_topping_default button[data-action=remove]').parent().parent().removeClass('disabled-topping');
				}
			}	
			$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-price', parseFloat(new_total_price).toFixed(0));
			if( is_buy_x_free_x ){
				$('span#product_subtotal').html(`<i class="currency"></i>`+numberWithCommas(parseFloat(new_total_price).toFixed(0)));
			}else{
				$('span#product_subtotal').html(`+ <i class="currency"></i>`+numberWithCommas(parseFloat(new_total_price).toFixed(0)));
			}
		}else{
			// console.log('Maximum add 2 toppings');
		}
	});

	/* add product to cart */
	$('body').on('click', '.add-product-cart', function(e){
		e.preventDefault();
		var _this = $(this);
		var store_code = $('#checking_variables').attr('data-store_code');
		var storage_domain_url = $(this).attr('data-domain');
		var product_sku = $(this).attr('data-sku');
		localStorage.setItem('storage_domain_url', storage_domain_url);
		var category_type = $(this).attr('data-category');
		localStorage.setItem('category_type', category_type);
		var data = {
			crust_code : $(this).attr('data-crust_code'),
			price : $(this).attr('data-price'),
			size_code : $(this).attr('data-size_code'),
			sku : product_sku,
			category_type: category_type,
			type : $(this).attr('data-type'),
			upgrades : $(this).attr('data-upgrades'),
		};
		$.post("/cart/add-item",data).done(function(data) {
			addItemCart(data.cart);
			$('#checking_variables').attr('data-emarsys_cart_items', data.emarsys_cart_items);
			//Update Emarsys tracking
			// if( typeof ScarabQueue !== "undefined" ){
			// 	ScarabQueue.push(['cart',  JSON.parse(data.emarsys_cart_items)]);
			// 	ScarabQueue.push(['go']);	
			// }
			$(".free-items").remove();
			var qty = 0;
			$.each( JSON.parse(data.cart), function( index, value ) {
				qty += value.qty;
				$(".product-item").find(`[data-sku='${value.sku}']`).find('span.cart-item-count').html(value.qty).toggleClass('d-none', value.qty < 1);
			});
			var return_data = calculateNewPoint(data.total_price);
			$('span#earn_reward').html(return_data.earn_point);
			$('span#new_reward').html(return_data.total_point);
			$('#checkout_btn').attr('data-points', return_data.total_point);
			$('.basket-subtotal').removeClass('d-none');
			$('.subtotal-wrapper').addClass('bg-white');
			$('.basket-suggestion').removeClass('d-none').addClass('d-block');
			$('.basket-suggestion').addClass('bg-white');
			$('.basket-checkout-btn').removeClass('d-none').addClass('d-block');
			if( store_code ){
				$('.basket-voucher').removeClass('d-none').addClass('d-block');	
			}
			$('#min_order').addClass('d-none');
			$('#empty_message').addClass('d-none');
			if( data.check_not_available_cart_item == false ){
				$('#out_of_stock_text').remove();
				$("#checkout_btn").prop('disabled', false);
			}else{
				$('#checkout_btn').prop("disabled", true);	
			}
			$('span.subtotal').html('<i class="currency"></i>'+numberWithCommas(parseFloat(data.subtotal_price).toFixed(0)));
			// $('span.quantity').html(qty);
			$('span.cart-count').html(qty).toggleClass('d-none', qty < 1);
			$('span.total-price').html('<i class="currency"></i>'+numberWithCommas(parseFloat(data.total_price).toFixed(0)));
			if( data.discount_amount > 0 ){
				$('.subtotal-price .voucher-amount').html('- <i class="currency"></i>'+numberWithCommas(parseFloat(data.discount_amount).toFixed(0)))
				if( data.discount_rate > 0 ){
					$('.subtotal-detail .voucher-label').html('Discount '+parseFloat(data.discount_rate).toFixed(0)+'%');
				}	
			}
			if( data.delivery_fee > 0 ){
				$('span.delivery-fee').html('<i class="currency"></i>'+numberWithCommas(parseFloat(data.delivery_fee).toFixed(0)));
			}else{
				$('span.delivery-fee').html('FREE');
			}
			localStorage.removeItem('storage_domain_url');
			localStorage.removeItem('category_type');
			$("#main_content").append('<div class="alert alert-success alert-block">' + data.notificationText + '</div>');
		}).fail(function(jqXHR, textStatus, errorThrown) {
			$("#main_content").append('<div class="alert alert-danger alert-block">' + jqXHR.responseJSON.notificationText + '</div>');
			if( jqXHR.responseJSON.type == 'sold out' ){
				$('.details-wrap[data-sku='+product_sku+']').addClass('sold-out');
				$('.customise-button[data-sku='+product_sku+']').remove();
				$('.product-builder-btn[data-sku='+product_sku+']').addClass('disabled');
				$('.add-product-cart[data-sku='+product_sku+']').removeClass('add-product-cart').removeClass('button--primary--small').removeClass('justify-content-between').addClass('justify-content-center').addClass('disabled').addClass('button--secondary--small').attr('disabled', true).html('<span class="text-capitalize">'+jqXHR.responseJSON.type+'</span>');	
			}
		});
	});

	$('body').on('click', '#add_to_cart', function(e){
		e.preventDefault();
		var store_code = $('#checking_variables').attr('data-store_code');
		var action = $(this).attr('data-action');
		var product_sku = $(this).attr('data-sku');
		var category_type = localStorage.getItem('category_type');
		var url = "/cart/add-item";
		var data = {
			crust_code : $(this).attr('data-crust_code'),
			price : $(this).attr('data-price'),
			size_code : $(this).attr('data-size_code'),
			sku : product_sku,
			category_type: category_type,
			type : $(this).attr('data-type'),
			upgrades : $(this).attr('data-upgrades'),
		};
		if( action == 'edit' ){
			url = "/cart/edit-item";
			data = {
				cart_index : $(this).attr('data-id'),
				crust_code : $(this).attr('data-crust_code'),
				price : $(this).attr('data-price'),
				size_code : $(this).attr('data-size_code'),
				sku : $(this).attr('data-sku'),
				type : $(this).attr('data-type'),
				upgrades : $(this).attr('data-upgrades'),
			};
		}
		$.post(url, data).done(function(data) {
			$('#checking_variables').attr('data-emarsys_cart_items', data.emarsys_cart_items);
			//Update Emarsys tracking
			// if( typeof ScarabQueue !== "undefined" ){
			// 	ScarabQueue.push(['cart',  JSON.parse(data.emarsys_cart_items)]);
			// 	ScarabQueue.push(['go']);	
			// }
			addItemCart(data.cart);
			$(".free-items").remove();
			$('#product-builder-modal').modal('hide');
			$('#product_sizes_crusts_select').html('');
			$('#product_topping_default').html('');
			$('#product_topping_extra').html('');
			$('#additional_note').html('');
			$('#removed_note').html('');
			var qty = 0;
			$.each( JSON.parse(data.cart), function( index, value ) {
				qty += value.qty;
			});
			/* update reward basket */
			var return_data = calculateNewPoint(data.total_price);
			$('span#earn_reward').html(return_data.earn_point);
			$('span#new_reward').html(return_data.total_point);
			$('#checkout_btn').attr('data-points', return_data.total_point);
			/* update basket total*/
			$('.basket-subtotal').removeClass('d-none');
			$('.subtotal-wrapper').addClass('bg-white');
			$('.basket-suggestion').removeClass('d-none').addClass('d-block');
			$('.basket-checkout-btn').removeClass('d-none').addClass('d-block');
			if( store_code ){
				$('.basket-voucher').removeClass('d-none').addClass('d-block');	
			}
			$('#min_order').addClass('d-none');
			$('#empty_message').addClass('d-none');
			if( data.check_not_available_cart_item == false ){
				$('#out_of_stock_text').remove();
				$("#checkout_btn").prop('disabled', false);
			}else{
				$('#checkout_btn').prop("disabled", true);	
			}
			$('span.subtotal').html('<i class="currency"></i>'+numberWithCommas(parseFloat(data.subtotal_price).toFixed(0)));
			// $('span.quantity').html(qty);
			$('span.cart-count').html(qty).toggleClass('d-none', qty < 1);
			$('span.total-price').html('<i class="currency"></i>'+numberWithCommas(parseFloat(data.total_price).toFixed(0)));
			if( data.discount_amount > 0 ){
				$('.subtotal-price .voucher-amount').html('- <i class="currency"></i>'+numberWithCommas(parseFloat(data.discount_amount).toFixed(0)))
				if( data.discount_rate > 0 ){
					$('.subtotal-detail .voucher-label').html('Discount '+parseFloat(data.discount_rate).toFixed(0)+'%');
				}	
			}
			if( data.delivery_fee > 0 ){
				$('span.delivery-fee').html('<i class="currency"></i>'+numberWithCommas(parseFloat(data.delivery_fee).toFixed(0)));
			}else{
				$('span.delivery-fee').html('FREE');
			}
			localStorage.removeItem('storage_domain_url');
			localStorage.removeItem('category_type');
			$("#main_content").append('<div class="alert alert-success alert-block">' + data.notificationText + '</div>');
		}).fail(function(jqXHR, textStatus, errorThrown) {
			$('#product-builder-modal').modal('hide');
			$("#main_content").append('<div class="alert alert-danger alert-block">' + jqXHR.responseJSON.notificationText + '</div>');
			if( jqXHR.responseJSON.type && jqXHR.responseJSON.type == 'sold out' ){
				$(this).removeClass('.add-product-cart').addClass('disabled').attr('disabled', true).html('<span class="text-capitalize">'+jqXHR.responseJSON.type+'</span>');	
				if( jqXHR.responseJSON.type == 'sold out' ){
				$('.details-wrap[data-sku='+product_sku+']').addClass('sold-out');
				$('.customise-button[data-sku='+product_sku+']').remove();
				$('.product-builder-btn[data-sku='+product_sku+']').addClass('disabled');
				$('.add-product-cart[data-sku='+product_sku+']').removeClass('add-product-cart').removeClass('button--primary--small').removeClass('justify-content-between').addClass('justify-content-center').addClass('disabled').addClass('button--secondary--small').attr('disabled', true).html('<span class="text-capitalize">'+jqXHR.responseJSON.type+'</span>');	
			}
			}
		});
	});

	/* remove product from cart */	
	$('body').on('click', '.remove-btn', function(e){
		$($(this).attr('data-remove')).addClass('d-none').removeClass('d-flex');
		$.get('/cart/remove-item', { 
			item_code : $(this).attr('data-id') 
		}).done(function(data){
			// Refresh the page after remove cart
			location.reload();

		}).fail(function(jqXHR, textStatus, errorThrown) {
			console.log(jqXHR, textStatus, errorThrown);
		});
	});	

	/* select crust */
	$('body').on('click', '.product-crust', function(e){
		var new_total = 0;
		var type = $('#product-builder-modal #add_to_cart').attr('data-type');
		var find_selected_option = $('.product-crust.selected-crust-option');
		var type_name = $('#product-builder-modal .add-to-deals').attr('data-type_name');
		var option = $(this).attr('data-option');
		var size_name = option.split(' ', 1);
		var size_code = $(this).attr('data-size');
		var crust_name = option.substr(option.indexOf(" ") + 1);
		var crust_code =  $(this).attr('data-crust');
		var product_name = $('.product-details h2').text();
		var product_ingredients = localStorage.getItem('data-ingredients');
		var toppings_upgrade = localStorage.getItem('toppings_upgrade');
		var item_qty = localStorage.getItem('existing_cart_qty') ? localStorage.getItem('existing_cart_qty') : 1;
		var is_buy_x_free_x = $('.add-to-deals').attr('data-buy_x_free_x');

		if( product_ingredients ){
			buildTopping(JSON.parse(product_ingredients));
			if( toppings_upgrade ){
				var obj_upgrade = JSON.parse(toppings_upgrade);
				var filter_upgrade_add = _.filter(obj_upgrade, function(o){ return o.action == 'add' });
				var filter_upgrade_remove = _.filter(obj_upgrade, function(o){ return o.action == 'remove' });
				if( filter_upgrade_add.length >= 2 ){
					$('#product_topping_extra button[data-action=add]').addClass('disabled-button');
					$('#product_topping_extra button[data-action=add]').parent().parent().addClass('disabled-topping');
					$('#product_topping_extra .default-topping').removeClass('disabled-topping');
					$('#product_topping_extra .default-topping button[data-action=add]').removeClass('disabled-button');
				}
				if( filter_upgrade_remove.length >= 2 ){
					$('#product_topping_default button[data-action=remove]').addClass('disabled-button');
					$('#product_topping_default button[data-action=remove]').parent().parent().addClass('disabled-topping');	
					$('#product_topping_default .extra-topping').removeClass('disabled-topping');
					$('#product_topping_default .extra-topping button[data-action=remove]').removeClass('disabled-button');
				}

				if( filter_upgrade_add.length > 0 ){
					$.each( obj_upgrade, function( index, value ) {
						if( value.action == 'add' ){
							var new_selected_topping = _.filter(JSON.parse(product_ingredients), function(o){ 
								return o.default == 0 && o.active == 1 && o.ingredient_code == value.code;
							});
							var new_selected_price = new_selected_topping[0].price[size_code];
							buildAddedTopping(size_code,value.code,value.name,parseFloat(new_selected_price.price)*item_qty);	
							new_total += parseFloat(new_selected_price.price) * item_qty;
							obj_upgrade[index].price = parseFloat(new_selected_price.price);
						}
					});
					localStorage.setItem('toppings_upgrade', JSON.stringify(obj_upgrade));
				}
				if( filter_upgrade_remove.length > 0 ){
					$.each( obj_upgrade, function( index, value ) {
						if( value.action == 'remove' ){
							$('#product_topping_default button[data-size='+size_code+'][data-code='+value.code+']').parent().parent().remove();
							buildRemovedTopping(size_code,value.code,value.name,parseFloat(value.price)*item_qty);	
						}	
					});
				}
				$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-upgrades', JSON.stringify(obj_upgrade));
			}
		}
		$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').prop('disabled', false);
		if( find_selected_option.length > 0 ){
			var selected_option_crust_code = find_selected_option.attr('data-crust');
			find_selected_option.removeClass('selected-crust-option');
			find_selected_option.find('.product-crust-icon .pizzahut-crusts-icons').removeClass('phc-selected-crust').addClass('phc-'+selected_option_crust_code.toLowerCase());
		}
		$(this).addClass('selected-crust-option');
		$(this).find('.product-crust-icon .pizzahut-crusts-icons').removeClass('phc-'+crust_code.toLowerCase()).addClass('phc-selected-crust');
		$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-size_name', size_name);
		$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-crust_name', crust_name);
		$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-product_name', product_name);
		$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-size_code', size_code);
		$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr('data-crust_code', crust_code);
		new_total += parseFloat($(this).attr('data-price'));
		$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr( 'data-variance_price', parseFloat($(this).attr('data-price')).toFixed(0));
		$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').attr( 'data-price', parseFloat(new_total).toFixed(0));
		if(is_buy_x_free_x){
			$('#product_subtotal').html( '<i class="currency"></i>'+numberWithCommas(parseFloat(new_total).toFixed(0)));
		}else{
			$('#product_subtotal').html( '+ <i class="currency"></i>'+numberWithCommas(parseFloat(new_total).toFixed(0)));
		}
		$('.product-selected-size-crust span').html($(this).attr('data-option'));
		$('#product_sizes_crusts_select').addClass('d-none');
		$('.product-selected-size-crust').removeClass('d-none');
		if( type == 'PIZZA' || type_name == 'PIZZA' ){
			$('.product-toppings').removeClass('d-none');
			$('#product_topping_default .size-'+size_code).removeClass('d-none').addClass('d-flex');
			$('#product_topping_extra .size-'+size_code).removeClass('d-none').addClass('d-flex');
		}
	});

	/* change size crust */
	$('body').on('click', '.change-size-crust-btn', function(e){
		$('#product_sizes_crusts_select').removeClass('d-none');
		$('.product-toppings').addClass('d-none');
		$('.product-selected-size-crust').addClass('d-none');
		$('#product_topping_extra .product-topping-extra-option').addClass('d-none').removeClass('d-flex');
		$('#product_topping_default .product-topping-default-option').addClass('d-none').removeClass('d-flex');
	});

	/* change sauce */
	$('body').on('click', '.change-sauce-btn', function(e){
		$('.product-sauce-selected').addClass('d-none');
		$('.product-sauce-options').removeClass('d-none');
	});

	/* change sauce option on click */
	$('body').on('change, click', 'input[type="radio"][name=sauce]', function(e){
	    $('#sauce_option').html($(this).attr('data-name'));
	    $('.product-sauce-selected').removeClass('d-none');
		$('.product-sauce-options').addClass('d-none');
	});

	/* change cheese */
	$('body').on('click', '.change-cheese-btn', function(e){
		$('.product-cheese-selected').addClass('d-none');
		$('.product-cheese-options').removeClass('d-none');
	});

	/* change cheese option on click */
	$('body').on('change, click', 'input[type="radio"][name=cheese]', function(e){
	    $('#cheese_option').html($(this).attr('data-name'));
	    $('.product-cheese-selected').removeClass('d-none');
		$('.product-cheese-options').addClass('d-none');
	});

	/* Hide Porduct Builder Modal */
	$('body').on('hide.bs.modal', '#product-builder-modal', function(e){
		window.history.pushState( {} , '', '?' );
		localStorage.removeItem('data-ingredients');
		localStorage.removeItem('storage_domain_url');
		localStorage.removeItem('category_type');
		localStorage.removeItem('toppings_upgrade');
		localStorage.removeItem('existing_cart_qty');
		$('#product_sizes_crusts_select').html('');
		$('#product_topping_default').html('');
		$('#product_topping_extra').html('');
		$('#additional_note').html('');
		$('#removed_note').html('');
		$('#flavor_part').html('');
		$('#product_topping_extra').attr('data-extra_toppings', '');
		$('#product_topping_default').attr('data-default_toppings', '');
		$('#add_to_cart').prop('disabled', true);
		$('#product-builder-modal .add-to-deals').prop('disabled', true);
		$('#product-builder-modal .product-builder-image').removeAttr("style");
		$('#product-builder-modal .product-builder-image img').attr('src', '/images/wizard-generic-deal.jpg');
		$('#add_to_cart').attr('data-upgrades', '');
		$('.add-to-deals').attr('data-upgrades', '');
		$('#add_to_cart').removeAttr('data-action');
		$('.add-to-deals').removeAttr('data-action');
		$('#product_topping_default').attr('data-current_total', 0);
		$('#product_topping_default').attr('data-default_total', 0);
		$('#product_subtotal').html('+ <i class="currency"></i>0');
		$('#product_sizes_crusts_select').removeClass('d-none');
		$('.product-toppings').addClass('d-none');
		$('.product-selected-size-crust').addClass('d-none');
	});

	/* add product to deals */
	$('body').on('click', '.add-to-deals', function(e){
		e.preventDefault();
		var data = {
			crust_name : $(this).attr('data-crust_name'),
			size_name : $(this).attr('data-size_name'),
			product_name : $(this).attr('data-product_name'),
			sku : $(this).attr('data-sku'),
			price : $(this).attr('data-price'),
			variance_price : $(this).attr('data-variance_price'),
			crust_code : $(this).attr('data-crust_code'),
			size_code : $(this).attr('data-size_code'),
			type : $(this).attr('data-type'),
			upgrades : $(this).attr('data-upgrades'),
			parent_element : $(this).attr('data-parent_element'),
			element : $(this).attr('data-element'),
			type_name : $(this).attr('data-type_name'),
			storage_url : $(this).attr('data-domain'),
			deal_detail_id : $(this).attr('data-deal_detail_id'),
			product_id : $(this).attr('data-product_id'),
			is_buy_x_free_x: $(this).attr('data-buy_x_free_x'),
			product_charge_item_count: $(this).attr('data-product_charge_item_count'),
		};

		var deal_product_key = parseInt(data.parent_element.replace('deal-wrap-', ''));
		var items = addItemToDeal(data, deal_product_key);
		var object_items = JSON.parse(items);


		if( data.is_buy_x_free_x ){
			var flattened_object_items = _.flattenDeep(object_items);
			var sorted_data_array = _.orderBy(flattened_object_items, [(o) => parseFloat(o.total_price)], ['desc']);
			var top_n_arrays = data.product_charge_item_count < sorted_data_array.length ? _.take(sorted_data_array, data.product_charge_item_count) : sorted_data_array;

			console.log(object_items, flattened_object_items, sorted_data_array, top_n_arrays);

			var sum_additional_total = _.sumBy(top_n_arrays, (o) => parseFloat(o.total_price));
		} else {
			var sum_additional_total = _.sumBy(object_items, (o) => parseFloat(o.total_price));		
		}

		// var sum_additional_total = data.is_buy_x_free_x ? parseFloat(_.maxBy(object_items, function(o){ return parseFloat(o.total_price) }).total_price) :  _.sumBy(object_items, function(o){ return parseFloat(o.total_price) });


		if( data.is_buy_x_free_x ){
			$('input[name=price]').val(sum_additional_total);
		}

		var deal_price = data.is_buy_x_free_x ? sum_additional_total  : $('input[name=price]').val();
		var deal_total_price = data.is_buy_x_free_x ? parseFloat(deal_price) : parseFloat(deal_price) + sum_additional_total;
		var additional_price = data.is_buy_x_free_x ? 0 : sum_additional_total.toFixed(0);

		$('#deal_total_price').html(numberWithCommas(deal_total_price.toFixed(0)));
		$('input[name=additional_price]').val(additional_price);
		$('#product_sizes_crusts_select').html('');
		$('#product_topping_default').html('');
		$('#product_topping_extra').html('');
		$('#additional_note').html('');
		$('#removed_note').html('');
		$('input[name=items]').val(items);
		if( isMobileTablet() ){
			$('#'+data.element).modal('hide');
		}else{
			$('#'+data.element).collapse('hide');	
		}

		$('#'+data.parent_element).addClass('added');
		$('#'+data.parent_element).data('additional-price', sum_additional_total);
		$('#'+data.parent_element).children('[data-bs-target="#'+data.element+'"]').removeClass('d-sm-flex d-none d-flex d-sm-none').addClass('d-none');
		$('#'+data.parent_element).children('.deal-item-header-added').removeClass('d-none');
		var variance_price_text = parseFloat(data.variance_price).toFixed(0) == 0 ? '' : ( data.is_buy_x_free_x ? '<i class="currency"></i>'+numberWithCommas(parseFloat(data.variance_price).toFixed(0)) : '+<i class="currency"></i>'+numberWithCommas(parseFloat(data.variance_price).toFixed(0)) );
		$('#'+data.parent_element).children('.deal-item-header-added').children('.deals-item-added-details').attr('data-deal_item', JSON.stringify(data));
		$('#'+data.parent_element).children('.deal-item-header-added').children('.deals-item-added-details').html(`
				<div class="text-capitalize font-weight-400 font-family-sans line-height-1 d-flex justify-content-between">
					<span class="deals-details">`+data.size_name.toLowerCase()+` `+data.type_name.toLowerCase()+`</span>
					<span class="deals-price"></span>
				</div>
				<div class="text-capitalize typography-5 mb-0 font-weight-700 font-family-theme d-flex justify-content-between">
					<span class="deals-details">`+data.product_name.toLowerCase()+`</span>
					<span class="deals-price"><small class="text-grey">`+variance_price_text+`</small></span>
				</div>
				<div class="text-capitalize font-weight-400 font-family-sans text-grey line-height-1 d-flex justify-content-between">
					<span class="deals-details">`+data.crust_name.toLowerCase()+`</span>
					<span class="deals-price"></span>
				</div>
		`);
		if( data.upgrades != "" ){
			$.each( JSON.parse(data.upgrades) , function( key, upgrade ) {
				var add_text = Lang.get('js-return-text.label_add_topping');
				var remove_text = Lang.get('js-return-text.label_remove_topping');
				if( upgrade.action == 'remove' ){
					$('#'+data.parent_element).children('.deal-item-header-added').children('.deals-item-added-details').append(`
						<div class="font-weight-400 font-family-sans text-grey line-height-1 text-capitalize d-flex justify-content-between">
							<span class="deals-details"><small><span class="font-weight-600 text-theme-red">`+remove_text+`</span> `+upgrade.name.toLowerCase()+`</small></span>
							<span class="deals-price"></span>
						</div>
					`);
				}else{
					$('#'+data.parent_element).children('.deal-item-header-added').children('.deals-item-added-details').append(`
						<div class="font-weight-400 font-family-sans text-grey line-height-1 text-capitalize d-flex justify-content-between">
							<span class="deals-details"><small><span class="font-weight-600 text-green">`+add_text+`</span> `+upgrade.name.toLowerCase()+`</small></span>
							<span class="deals-price"><small>+<i class="currency"></i>`+numberWithCommas(parseFloat(upgrade.price).toFixed(0))+`</small></span>
						</div>
					`);
				}
			});
		}
		if( $('.deal-single-item-wrap').length == $('.deal-single-item-wrap.added').length ){
			$('.deal-add-to-cart').removeClass('d-none');
		}
		$('#product-builder-modal').modal('hide');
	});

	/*remove product from deals*/
	$('body').on('click', '.remove-deals-button', function(e){
		e.preventDefault();
		var data = {
			parent_element : $(this).attr('data-parent_element'),
			element : $(this).attr('data-element'),
			id : $(this).attr('data-id'),
		};
		var items = removeItemToDeal(data);
		var current_additional = $('input[name=additional_price]').val();
		var item_additional = $('#'+data.parent_element).data('additional-price');
		var new_current_additional = parseFloat(current_additional) - parseFloat(item_additional);
		$('input[name=additional_price]').val(new_current_additional.toFixed(0));

		$('input[name=items]').val(items);
		if( isMobileTablet() ){
			$('#'+data.element).modal('show', { keyboard: false, backdrop: 'static' });
		}else{
			$('#'+data.element).collapse('toggle');	
		}
		$('#'+data.parent_element).removeClass('added');
		$('#'+data.parent_element).children('[data-bs-target="#'+data.element+'"]:first-child').removeClass('d-none').addClass('d-sm-flex d-none');
		$('#'+data.parent_element).children('[data-bs-target="#'+data.element+'"]:nth-child(2)').removeClass('d-none').addClass('d-flex d-sm-none');
		$('#'+data.parent_element).children('.deal-item-header-added').addClass('d-none');
		$('.deal-add-to-cart').addClass('d-none');
	});	

	/* product builder modal trigger */
	$('body').on('click', '.product-builder-btn:not(.disabled)', function(e){
		e.preventDefault();
		var sku = $(this).attr('data-sku');
		var modal_id = $(this).attr('data-bs-target');
		var image_url = $(this).attr('data-domain');
		var category_type = $(this).attr('data-category');
		localStorage.setItem('category_type', category_type);
		var modal = $(modal_id);
		window.history.pushState( {} , '', '?'+sku );
		$.post("/find-product-with-sku", {
			sku: sku,
			category_type: category_type
		}).done(function(data) {
			if( data.product.image_path && data.product.image_vertical_path ){
				modal.find('.product-builder-image').css("background-image", `url(${image_url+data.product.image_vertical_path})`);
				modal.find('.product-builder-image img').attr('src', image_url+data.product.image_path);
			}
			localStorage.setItem('storage_domain_url', image_url);
			modal.find('.product-details h2').html(data.product.name);
			modal.find('.product-details h3').html(data.product.name);
			modal.find('.product-details p').html(data.product.description);
			modal.find('#add_to_cart').attr( 'disabled', true );
			modal.find('#add_to_cart').attr( 'data-type', data.product.type );
			modal.find('#add_to_cart').attr( 'data-sku', data.product.sku );
			modal.find('#add_to_cart').attr( 'data-price', data.product_variances[0].price );
			modal.find('#add_to_cart').attr( 'data-size_code', data.product_variances[0].size_code );
			modal.find('#add_to_cart').attr( 'data-crust_code', data.product_variances[0].crust_code );
			modal.find('#add_to_cart').attr('data-action', 'add');
			if( data.product_flavours ){
				buildFlavourIcon(data.product_flavours);	
			}
			if( data.product.type == 'PIZZA' ){
				buildSizeCrust(data.product_variances);
				buildTopping(data.product_ingredients);
				localStorage.setItem('data-ingredients', JSON.stringify(data.product_ingredients));
			}else{
				$('.product-sizes-crusts h4').addClass('d-none');
				buildSize(data.product_variances);
			}
			modal.modal('show', {keyboard: false, backdrop: 'static'});
			
		}).fail(function(jqXHR, textStatus, errorThrown) {
			console.log(jqXHR, textStatus, errorThrown);
		});
	});	

	/* edit product builder modal trigger */
	$('body').on('click', '.edit-product-builder-btn', function(e){
		e.preventDefault();
		var sku = $(this).attr('data-sku');
		var cart = $(this).attr('data-cart');
		var modal_id = $(this).attr('data-bs-target');
		var image_url = $(this).attr('data-domain');
		var cart_index = $(this).attr('data-id');
		var category_type = $(this).attr('data-category');
		localStorage.setItem('category_type', category_type);
		var modal = $(modal_id);
		window.history.pushState( {} , '', '?'+sku );
		$.post("/find-product-with-sku", {
			sku: sku,
			category_type: category_type
		}).done(function(data) {
			if( data.product.image_path && data.product.image_vertical_path ){
				modal.find('.product-builder-image').css("background-image", "url('"+ image_url + data.product.image_vertical_path + "')");
				modal.find('.product-builder-image img').attr('src', image_url+data.product.image_path);
			}
			localStorage.setItem('storage_domain_url', image_url);
			var existing_cart = JSON.parse(cart);
			var toppings_upgrade = existing_cart.upgrades ? JSON.stringify(existing_cart.upgrades) : '';
			modal.find('.product-details h2').html(data.product.name);
			modal.find('.product-details h3').html(data.product.name);
			modal.find('.product-details p').html(data.product.description);
			modal.find('#add_to_cart').attr( 'disabled', false );
			modal.find('#add_to_cart').attr( 'data-type', existing_cart.type );
			modal.find('#add_to_cart').attr( 'data-sku', existing_cart.sku );
			modal.find('#add_to_cart').attr( 'data-price', existing_cart.total_price );
			modal.find('#add_to_cart').attr( 'data-size_code', existing_cart.size_code );
			modal.find('#add_to_cart').attr( 'data-crust_code', existing_cart.crust_code );
			modal.find('#add_to_cart').attr( 'data-upgrades', toppings_upgrade);
			modal.find('#add_to_cart').attr( 'data-id', cart_index);
			modal.find('#add_to_cart').attr( 'data-action', 'edit');
			localStorage.setItem('toppings_upgrade', toppings_upgrade);
			localStorage.setItem('existing_cart_qty', existing_cart.qty);
			modal.find('#add_to_cart #product_subtotal').html( '+ <i class="currency"></i>'+numberWithCommas(parseFloat(existing_cart.total_price ).toFixed(0)));
			if( data.product_flavours ){
				buildFlavourIcon(data.product_flavours);	
			}
			if( data.product.type == 'PIZZA' ){
				buildSizeCrust(data.product_variances);
				buildTopping(data.product_ingredients);
				if( existing_cart.upgrades ){
					toppingsAddNote(existing_cart.upgrades);
					var filter_upgrade_add = _.filter(existing_cart.upgrades, function(o){ return o.action == 'add' });
					var filter_upgrade_remove = _.filter(existing_cart.upgrades, function(o){ return o.action == 'remove' });
					if( filter_upgrade_add.length >= 2 ){
						$('#product_topping_extra button[data-action=add]').addClass('disabled-button');
						$('#product_topping_extra button[data-action=add]').parent().parent().addClass('disabled-topping');
						$('#product_topping_extra .default-topping').removeClass('disabled-topping');
						$('#product_topping_extra .default-topping button[data-action=add]').removeClass('disabled-button');
					}
					if( filter_upgrade_remove.length >= 2 ){
						$('#product_topping_default button[data-action=remove]').addClass('disabled-button');
						$('#product_topping_default button[data-action=remove]').parent().parent().addClass('disabled-topping');	
						$('#product_topping_default .extra-topping').removeClass('disabled-topping');
						$('#product_topping_default .extra-topping button[data-action=remove]').removeClass('disabled-button');
					}
					if( filter_upgrade_add.length > 0 ){
						$.each( filter_upgrade_add, function( index, value ) {
							buildAddedTopping(existing_cart.size_code,value.code,value.name,parseFloat(value.price)*existing_cart.qty);		
						});
					}
					if( filter_upgrade_remove.length > 0 ){
						$.each( filter_upgrade_remove, function( index, value ) {
							$('#product_topping_default button[data-size='+existing_cart.size_code+'][data-code='+value.code+']').parent().parent().remove();
							buildRemovedTopping(existing_cart.size_code,value.code,value.name,parseFloat(value.price)*existing_cart.qty);	
						});
					}
				}
				localStorage.setItem('data-ingredients', JSON.stringify(data.product_ingredients));
				var selected_crust_size = existing_cart.size_name+' '+existing_cart.crust_name;
				if( lang == 'th' ){
					var selected_crust_size = existing_cart.size_name_thai+' '+existing_cart.crust_name_thai;
				}
				var selected_crust_option = $(`.product-crust[data-size='${existing_cart.size_code}'][data-crust='${existing_cart.crust_code}']`);
				$(selected_crust_option).addClass('selected-crust-option');
				$(selected_crust_option).find('.product-crust-icon .pizzahut-crusts-icons').removeClass('phc-'+existing_cart.crust_code.toLowerCase()).addClass('phc-selected-crust');
				$('.product-selected-size-crust span').html(selected_crust_size);
				$('#product_sizes_crusts_select').addClass('d-none');
				$('.product-selected-size-crust').removeClass('d-none');
				$('.product-toppings').removeClass('d-none');
				$('#product_topping_default .size-'+existing_cart.size_code).removeClass('d-none').addClass('d-flex');
				$('#product_topping_extra .size-'+existing_cart.size_code).removeClass('d-none').addClass('d-flex');
			}else{
				$('.product-sizes-crusts h4').addClass('d-none');
				buildSize(data.product_variances);
				$('.product-selected-size-crust span').html(existing_cart.size_name.toLowerCase());
				$('#product_sizes_crusts_select').addClass('d-none');
				$('.product-selected-size-crust').removeClass('d-none');
				$('#product-builder-modal #add_to_cart, #product-builder-modal .add-to-deals').prop('disabled', false);
			}
			modal.modal('show', {keyboard: false, backdrop: 'static'});
			
		}).fail(function(jqXHR, textStatus, errorThrown) {
			console.log(jqXHR, textStatus, errorThrown);
		});
	});

	/* edit deals product builder modal trigger */	
	$('body').on('click', '.deals-item-added-details:not(.disabled)', function(e){
		e.preventDefault();
		var deal_item_detail = $(this).attr('data-deal_item');
		var decode_deal_item = JSON.parse(deal_item_detail);
		var sku = decode_deal_item.sku;
		var image_url = decode_deal_item.storage_url;
		var deal_detail_id = decode_deal_item.deal_detail_id;
		var product_id = decode_deal_item.product_id;
		var modal = $('#product-builder-modal');
		window.history.pushState( {} , '', '?'+sku );
		$.post("/group-deal-product-variances", {
			sku: sku,
			deal_detail_id: deal_detail_id,
			product_id: product_id,
		}).done(function(data) {
			var new_data = data.product_list[product_id];
			if( new_data.product_item.image_vertical_path && new_data.product_item.image_path ){
				var display_image = new_data.product_item.image_path_deal_use ? image_url+new_data.product_item.image_path_deal_use : image_url+new_data.product_item.image_path;
				var display_image_vertical = new_data.product_item.image_vertical_path_deal_use ? image_url+new_data.product_item.image_vertical_path_deal_use : image_url+new_data.product_item.image_vertical_path;
				modal.find('.product-builder-image').css("background-image", "url('"+display_image_vertical+"')");
				modal.find('.product-builder-image img').attr('src', display_image);
			}
			var new_upgrade = (decode_deal_item.upgrades).replace(/[\\""]/g, '');
			if( new_upgrade ){
				var toppings_upgrade = JSON.parse(decode_deal_item.upgrades) ? decode_deal_item.upgrades : '';	
			}else{
				var toppings_upgrade = '';
			}
			modal.find('.product-details h2').html(new_data.product_item.name);
			modal.find('.product-details h3').html(new_data.product_item.name);
			modal.find('.product-details p').html(new_data.product_item.description);
			modal.find('.add-to-deals').attr( 'data-domain', image_url );
			modal.find('.add-to-deals').attr( 'data-action', 'add');
			modal.find('.add-to-deals').attr( 'disabled', false );
			modal.find('.add-to-deals').attr( 'data-parent_element', decode_deal_item.parent_element );
			modal.find('.add-to-deals').attr( 'data-deal_detail_id', deal_detail_id );
			modal.find('.add-to-deals').attr( 'data-product_id', product_id );
			modal.find('.add-to-deals').attr( 'data-element', decode_deal_item.element );
			modal.find('.add-to-deals').attr( 'data-type', decode_deal_item.type );
			modal.find('.add-to-deals').attr( 'data-type_name', decode_deal_item.type_name );
			modal.find('.add-to-deals').attr( 'data-sku', sku );
			modal.find('.add-to-deals').attr( 'data-upgrades', toppings_upgrade);
			modal.find('.add-to-deals').attr( 'data-price', decode_deal_item.price );
			modal.find('.add-to-deals').attr( 'data-variance_price', decode_deal_item.variance_price );
			modal.find('.add-to-deals').attr( 'data-crust_name', decode_deal_item.crust_name );
			modal.find('.add-to-deals').attr( 'data-crust_code', decode_deal_item.crust_code );
			modal.find('.add-to-deals').attr( 'data-size_name', decode_deal_item.size_name );
			modal.find('.add-to-deals').attr( 'data-size_code', decode_deal_item.size_code );
			modal.find('.add-to-deals').attr( 'data-product_name', decode_deal_item.product_name );
			var is_bxf1_deal = decode_deal_item.is_buy_x_free_x ? 1 : 0;
			modal.find('.add-to-deals').attr( 'data-buy_x_free_x', is_bxf1_deal );
			modal.find('.add-to-deals').attr( 'data-product_charge_item_count', decode_deal_item.product_charge_item_count);

			if( decode_deal_item.is_buy_x_free_x ){
				modal.find('.add-to-deals #product_subtotal').html( '<i class="currency"></i>'+numberWithCommas(parseFloat(decode_deal_item.price ).toFixed(0)));
			} else {
				modal.find('.add-to-deals #product_subtotal').html( '+<i class="currency"></i>'+numberWithCommas(parseFloat(decode_deal_item.price ).toFixed(0)));
			}

			localStorage.setItem('toppings_upgrade', toppings_upgrade);
			if( new_data.product_flavours ){
					buildFlavourIcon(new_data.product_flavours);	
				}
			if( new_data.type == 'PIZZA' ){
				buildSizeCrust(new_data.variances, 'deals');
				buildTopping(new_data.ingredients);
				if( new_upgrade ){
					var obj_deal_item_upgrades = JSON.parse(decode_deal_item.upgrades);
					toppingsAddNote( obj_deal_item_upgrades );
					var filter_upgrade_add = _.filter(obj_deal_item_upgrades, function(o){ return o.action == 'add' });
					var filter_upgrade_remove = _.filter(obj_deal_item_upgrades, function(o){ return o.action == 'remove' });
					if( filter_upgrade_add.length >= 2 ){
						$('#product_topping_extra button[data-action=add]').addClass('disabled-button');
						$('#product_topping_extra button[data-action=add]').parent().parent().addClass('disabled-topping');
						$('#product_topping_extra .default-topping').removeClass('disabled-topping');
						$('#product_topping_extra .default-topping button[data-action=add]').removeClass('disabled-button');
					}
					if( filter_upgrade_remove.length >= 2 ){
						$('#product_topping_default button[data-action=remove]').addClass('disabled-button');
						$('#product_topping_default button[data-action=remove]').parent().parent().addClass('disabled-topping');	
						$('#product_topping_default .extra-topping').removeClass('disabled-topping');
						$('#product_topping_default .extra-topping button[data-action=remove]').removeClass('disabled-button');
					}
					if( filter_upgrade_add.length > 0 ){
						$.each( filter_upgrade_add, function( index, value ) {
							buildAddedTopping(decode_deal_item.size_code,value.code,value.name,parseFloat(value.price));		
						});
					}
					if( filter_upgrade_remove.length > 0 ){
						$.each( filter_upgrade_remove, function( index, value ) {
							$('#product_topping_default button[data-size='+decode_deal_item.size_code+'][data-code='+value.code+']').parent().parent().remove();
							buildRemovedTopping(decode_deal_item.size_code,value.code,value.name,parseFloat(value.price));	
						});
					}
				}
				localStorage.setItem('data-ingredients', JSON.stringify(new_data.ingredients));
				var selected_crust_size = decode_deal_item.size_name+' '+decode_deal_item.crust_name;
				var selected_crust_option = $(`.product-crust[data-size='${decode_deal_item.size_code}'][data-crust='${decode_deal_item.crust_code}']`);
				$(selected_crust_option).addClass('selected-crust-option');
				$(selected_crust_option).find('.product-crust-icon .pizzahut-crusts-icons').removeClass('phc-'+decode_deal_item.crust_code.toLowerCase()).addClass('phc-selected-crust');
				$('.product-selected-size-crust span').html(selected_crust_size);
				$('#product_sizes_crusts_select').addClass('d-none');
				$('.product-selected-size-crust').removeClass('d-none');
				$('.product-toppings').removeClass('d-none');
				$('#product_topping_default .size-'+decode_deal_item.size_code).removeClass('d-none').addClass('d-flex');
				$('#product_topping_extra .size-'+decode_deal_item.size_code).removeClass('d-none').addClass('d-flex');
			}else{
				$('.product-sizes-crusts h4').addClass('d-none');
				buildSize(new_data.variances, 'deals');
			}
			modal.modal('show', {keyboard: false, backdrop: 'static'});
		}).fail(function(jqXHR, textStatus, errorThrown) {
			console.log(jqXHR, textStatus, errorThrown);
		});
	});

	/* deal product builder modal trigger */
	$('body').on('click', '.deals-product-builder-btn', function(e){
		e.preventDefault();
		var sku = $(this).attr('data-sku');
		var deal_detail_id = $(this).attr('data-deal_detail_id');
		var product_id = $(this).attr('data-product_id');
		var modal_id = $(this).attr('data-bs-target');
		if( isMobileTablet() ){
			var parent_element = $('.mobile-deal-modal.show').parent().attr('id');
			var element = $('.mobile-deal-modal.show').attr('id');	
		}else{
			var parent_element = $('.deal-item-header[aria-expanded=true]').parent().attr('id');
			var element = $('.deal-item-header[aria-expanded=true]').attr('aria-controls');	
		}
		var modal = $(modal_id);
		var image_url = $(this).attr('data-domain');
		window.history.pushState( {} , '', '?'+sku );
		$.post("/group-deal-product-variances", {
			sku: sku,
			deal_detail_id: deal_detail_id,
			product_id: product_id,
		}).done(function(data) {
			var new_data = data.product_list[product_id];
			if( new_data.product_item.image_vertical_path && new_data.product_item.image_path ){
				var display_image = new_data.product_item.image_path_deal_use ? image_url+new_data.product_item.image_path_deal_use : image_url+new_data.product_item.image_path;
				var display_image_vertical = new_data.product_item.image_vertical_path_deal_use ? image_url+new_data.product_item.image_vertical_path_deal_use : image_url+new_data.product_item.image_vertical_path;
				modal.find('.product-builder-image').css("background-image", "url('"+display_image_vertical+"')");
				modal.find('.product-builder-image img').attr('src', display_image);
			}
			modal.find('.product-details h2').html(new_data.product_item.name);
			modal.find('.product-details h3').html(new_data.product_item.name);
			modal.find('.product-details p').html(new_data.product_item.description);
			modal.find('.add-to-deals').attr( 'data-domain', image_url );
			modal.find('.add-to-deals').attr( 'data-action', 'add');
			modal.find('.add-to-deals').attr( 'disabled', true );
			modal.find('.add-to-deals').attr( 'data-parent_element', parent_element );
			modal.find('.add-to-deals').attr( 'data-deal_detail_id', deal_detail_id );
			modal.find('.add-to-deals').attr( 'data-product_id', product_id );
			modal.find('.add-to-deals').attr( 'data-element', element );
			modal.find('.add-to-deals').attr( 'data-type', new_data.type );
			modal.find('.add-to-deals').attr( 'data-type_name', new_data.type );
			modal.find('.add-to-deals').attr( 'data-sku', new_data.sku );
			var first_obj_key = Object.keys(new_data.variances)[0];
			var first_variance = new_data.variances[first_obj_key];
			modal.find('.add-to-deals').attr( 'data-price', 0 );
			modal.find('.add-to-deals').attr( 'data-variance_price', 0 );
			modal.find('.add-to-deals').attr( 'data-crust_name', first_variance.crust_name );
			modal.find('.add-to-deals').attr( 'data-crust_code', first_variance.crust_code );
			modal.find('.add-to-deals').attr( 'data-size_name', first_variance.size_name );
			modal.find('.add-to-deals').attr( 'data-size_code', first_variance.size_code );
			modal.find('.add-to-deals').attr( 'data-product_name', new_data.product_item.name );
			modal.find('.add-to-deals').attr( 'data-buy_x_free_x', first_variance.is_bxf1_deal );
			modal.find('.add-to-deals').attr( 'data-product_charge_item_count', first_variance.product_charge_item_count );

			if( first_variance.is_bxf1_deal ){ // if item is buy one free one
				modal.find('.add-to-deals #product_subtotal').html('<i class="currency"></i>0');
			}

			if( new_data.product_flavours ){
					buildFlavourIcon(new_data.product_flavours);	
				}
			if( new_data.type == 'PIZZA' ){
				buildSizeCrust(new_data.variances, 'deals');
				buildTopping(new_data.ingredients);
				localStorage.setItem('data-ingredients', JSON.stringify(new_data.ingredients));
			}else{
				$('.product-sizes-crusts h4').addClass('d-none');
				buildSize(new_data.variances, 'deals');
			}
			modal.modal('show', {keyboard: false, backdrop: 'static'});
		}).fail(function(jqXHR, textStatus, errorThrown) {
			console.log(jqXHR, textStatus, errorThrown);
		});
	});

	$('body').on('click', '#checkout_btn', function(e){
		e.preventDefault();
		var url = $(this).attr('data-url');
		var points = $(this).attr('data-points');
		$.post( url, {
			points : points,
		}).done(function(data) {
			$('#checkout-form').submit();
		}).fail(function(jqXHR, textStatus, errorThrown) {
			console.log(jqXHR, textStatus, errorThrown);
		});
	});

    /* Add voucher code */
	$('body').on('click', '#apply_voucher_code', function(e){
		e.preventDefault();
		var csrf_token = $('meta[name="csrf-token"]').attr('content'); // Get csrf token
		var voucher_code = $('input#voucher_code').val();
		if( voucher_code != '' ){
			var data = { 'voucher_code' : voucher_code,  '_token': csrf_token };
			$.post("/cart/add-voucher", data).done(function(data) {
				$.each(data, function(status, value) {
					if( status === 'Error' ){
						$('#voucher_modal').modal('hide');
						$('input#voucher_code').removeClass('is-valid').val("");
						$("#main_content").append('<div class="alert alert-danger">'+value+'</div>');
					}else{
						$("#main_content").append('<div class="alert alert-success">'+Lang.get('js-return-text.voucher_modal_activated_message')+'</div>');	
						$('#voucher_modal').modal('hide');
						$('input#voucher_code').removeClass('is-valid').val("");
						if( value.free_item ){
							window.location.href = `/voucher/free-item/${value.free_item}/${value.serial_code}`;
						}
						location.reload();
					}
				});
			});
		}else{
			$('#voucher_modal #voucher_code').addClass('is-invalid');
		}
	});

	// open voucher modal
	$('body').on('click', '#voucher', function(e){
		e.preventDefault();
		$('#voucher_modal').modal('show', { keyboard: false, backdrop: 'static' });
	});

	/* Auto return uppercase when user key in voucher code*/
	$('body').on('change paste keyup', 'input#voucher_code', function(e){
		var current_value = $(this).val();
		$(this).val( current_value.toUpperCase() );
	});

	/* Remove voucher code */
	$('body').on('click', '.remove-voucher-btn', function(e){
		e.preventDefault();
		var csrf_token = $('meta[name="csrf-token"]').attr('content'); // Get csrf token
		var voucher_code = $(this).attr('data-code');
		var data = { 'voucher_code' : voucher_code,  '_token': csrf_token };
		$.post("/cart/remove-voucher", data).done(function(data) {
			$.each(data, function(status, value) {
				if( status === 'Error' ){
					$("#main_content").append('<div class="alert alert-danger">'+value+'</div>');
				}else{
					location.reload();
				}
			});
		});
	});

	/* New Select Box Design */
		/* check offscreen */
		function isElementInViewport (el_id) {
            const currentElement = document.getElementById(el_id);
            const nextElement = currentElement.nextElementSibling;
            var rect = nextElement.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&     
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        /*Add trigger when event scroll*/
        $(window).on('scroll', function() {
            const open_selection_box_id = $('.pizza-selection.open').siblings('.select_trigger');
            if(open_selection_box_id.length > 0){
            	$('.pizza-selection.open').removeClass('show-top'); // Reset incase add show-top
            	// if over screen show top instead
            	if (!isElementInViewport(open_selection_box_id.attr('id'))) {
            		$('.pizza-selection.open').addClass('show-top');
            	}
            }
        });

		/* close drop down when click outside */
		$(window).click(function() {
	        // Close the dropdown if click outside
	        $('.pizza-selection.open').removeClass('open');
	    });

		var selectedCrust = {}; // Initialize with no selected crust

		/* open drop down when click select box */
		$('.select_trigger').click(function(e) {
			e.stopPropagation();
			$('.pizza-selection').removeClass('open'); // reset to turn off all the pizza selection opening
			var dropdown = $(this).next('.pizza-selection');
			dropdown.removeClass('show-top').addClass('open'); // open current pizza selection
			
			// if over screen show top instead
			if (!isElementInViewport($(this).attr('id'))) {
				dropdown.addClass('show-top');
			}
		
			// Update the selected size for the dropdown
			var selectedSize = "";
			dropdown.find('.size-select.chosen-pizza-size').each(function() {
				selectedSize = $(this).data('value');
			});

			// Add class Default is first option
			if( selectedSize == "" ) {
				dropdown.find('.size-select').each(function(index) {
					if( index == 0 ){
						$(this).addClass('chosen-pizza-size');
						selectedSize = $(this).data('value');
						return false;
					}
				});
			}
			
			// Show/hide crust options based on the selected size and crust
			dropdown.find('.crust-option').each(function() {
				var crustSize = $(this).data('size_code');
				var pizzaSku = $(this).data('sku'); // Using the SKU as the identifier
		
				if (crustSize === selectedSize) {
					$(this).show();
		
					// Highlight selected crust based on the selectedCrust object
					if (selectedCrust[pizzaSku] === $(this).data('crust_code')) {
						$(this).addClass('selected-crust');
					} else {
						$(this).removeClass('selected-crust');
					}
				} else {
					$(this).hide();
				}
			});
		});

		/* select crust option */
		$('.crust-option').on('click', function(e) {
			e.stopPropagation();
			var pizzaSku = $(this).data('sku');
			selectedCrust[pizzaSku] = $(this).data('crust_code');
			
			var sku = $(this).data('sku');
			var crustName = $(this).data('crust_name');
			var price = $(this).data('price');
			var crustCode = $(this).data('crust_code');
			var sizeCode = $(this).data('size_code');
			var priceWithoutDecimal = numberWithCommas(parseFloat(price).toFixed(0));
			var sizeName = $(this).data('size_name');
			var type = $(this).data('type');
		
			// Update crust name
			$('#span_name_' + sku).html(sizeName + ' ' + crustName);
			$('#span_price_' + sku).html(priceWithoutDecimal);
		
			// Update all attributes for add button
			$('#button_price_'+ sku).html('<i class="currency"></i>' + priceWithoutDecimal);
			$('.add-product-cart[data-sku="' + sku + '"]').attr('data-sku', sku);
			$('.add-product-cart[data-sku="' + sku + '"]').attr('data-price', price);
			$('.add-product-cart[data-sku="' + sku + '"]').attr('data-crust_code', crustCode);
			$('.add-product-cart[data-sku="' + sku + '"]').attr('data-size_code', sizeCode);
			$('.add-product-cart[data-sku="' + sku + '"]').attr('data-type', type);
		
			// Update all add to deals
			var button_deals = $('.add-to-deals[data-sku="' + sku + '"]');
		
			/* button product deals grid */
			button_deals.children('.product-price-btn').html('+<i class="currency"></i>'+priceWithoutDecimal);
			button_deals.attr('data-price', price);
			button_deals.attr('data-variance_price', price);
			button_deals.attr('data-crust_code', crustCode);
			button_deals.attr('data-size_code', sizeCode);
			button_deals.attr('data-crust_name', crustName);
			button_deals.attr('data-size_name', sizeName);
		
			// Close the dropdown
			$('.pizza-selection.open').removeClass('open');
		});
		
		/* select size option */
		$('.size-select').on('click', function(e) {
			e.stopPropagation();
			var pizzaDropdown = $(this).closest('.pizza-selection'); 
			// Get the closest pizza dropdown

			var sku = $(this).data('sku');
			selectedSize = $(this).data('value'); 
			// Update the selected size within the specific pizza dropdown

			pizzaDropdown.find('.size-select').removeClass('chosen-pizza-size'); 
			// Remove class from other size options within the specific pizza dropdown

			$(this).addClass('chosen-pizza-size'); 
			// Add class to clicked size option within the specific pizza dropdown

			// var isSelectedSize = $(this).hasClass('chosen-pizza-size');
			// var selectedIsLarge = $(this).data('value') === 'L';
			// var uniqueIdentifier = $(this).data('identifier');
			
			// $('.selected-size-background').each(function() {
			// 	var currentIdentifier = $(this).data('identifier');
		
			// 	if (currentIdentifier === uniqueIdentifier) {
			// 		$(this).css({
			// 			width: isSelectedSize ? '50%' : 0,
			// 			left: isSelectedSize ? (selectedIsLarge ? 0 : '50%') : 0,
			// 			right: isSelectedSize ? (selectedIsLarge ? 'auto' : '50%') : 0,
			// 			borderRadius: isSelectedSize ? (selectedIsLarge ? '0 0 0 10px' : '0 0 10px') : ''
			// 		});
			// 	} else {
			// 		$(this).css({
			// 			width: 0,
			// 			left: 0,
			// 			right: 0,
			// 			borderRadius: ''
			// 		});
			// 	}
			// });
			
			pizzaDropdown.find('.crust-option').each(function() {
				var crustSize = $(this).data('size_code');
				if (crustSize === selectedSize) {
					$(this).show();
					if ($(this).data('crust_code') === selectedCrust) {
						$(this).addClass('selected-crust');
					} else {
						$(this).removeClass('selected-crust');
					}
				} else {
					$(this).hide();
				}
			});
		});

	/* toggle button order type cart mobile view */
	$('#delivery-button').on('click', function() {
		$(this).addClass('active');
		$('#pickup-button').removeClass('active');
	});

	$('#pickup-button').on('click', function() {
		$(this).addClass('active');
		$('#delivery-button').removeClass('active');
	});

	window.formatPrice =function (price){
		// Convert the number to an integer
		var integer_number = Math.round(price);
		// Format the integer with commas using toLocaleString
		return integer_number.toLocaleString('en-US');
	}
});